import React, { Fragment } from 'react';
import { Container, Logo, Stack, Header } from '@ux/balance-react';
import "./NavHeader.css";
import { AppBar, Box, Toolbar, Typography, Button } from '@mui/material';
import itrLogo from '../../Assets/Images/itreasury-logo.png'
import { useHistory } from 'react-router-dom';

const NavHeader = () => {

    const history = useHistory();

    const logout = () => {
        history.push("/logout");
    }

    return(
        <>
            <Box sx={{ flexGrow: 1}}>
                <AppBar position="static" color='transparent' elevation={0}>
                    <Toolbar>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            <Logo />
                        </Typography>
                        <Typography sx={{ textAlign:'center' }}>
                            <img src={itrLogo} alt='itr logo' />
                            <p style={{ color:"#8fc340" }}>eLearning for New iTreasury</p>
                        </Typography>
                        <Button sx={{ color: "green" }} onClick={logout}>Logout</Button>
                    </Toolbar>
                    <div id='ribbon' />
                </AppBar>
            </Box>
        </>
    );
};

export default NavHeader;